/**
 * Represents the supported currencies list
 */
export enum Currency {
  USD = 'USD', // US Dollar
  CAD = 'CAD', // Canadian Dollar
  AUD = 'AUD', // Australian Dollar
  EUR = 'EUR', // Euro
  GBP = 'GBP', // British Pound
  JPY = 'JPY', // Japanese Yen
  KRW = 'KRW', // South Korean Won
  HKD = 'HKD', // Hong Kong Dollar
  CHF = 'CHF', // Swiss Frank
  SGD = 'SGD', // Singaporean Dollar
  NOK = 'NOK', // Norwegian Krona
  SEK = 'SEK', // Swedish Krona
  CNY = 'CNY', // Chinese Yuan (onshore)
  CNH = 'CNH', // Chinese Yuan (offshore)
}
